<template>
  <div>
    <div class="container">
      <el-button type="success" size="mini" @click="addChild1()">新增时间段</el-button>
      <!-- v-if="index===0" -->
      <div style="color: red;margin: 10px 0;font-size: 12px;">
        注意，一天的时间段不能重叠，比如1-5时间内包含的2点-4点不能重复选择(下面的内容容器可手动滚动)
      </div>
      <div>
        <div style="max-height: 70vh; overflow-y: auto;">
          <div v-for="(item, index) in allobj1" :key="index">
            <el-divider style="color: chartreuse !important;" content-position="left">第{{ index+1 }}条时间段</el-divider>
            <div class="aa">
              <el-time-select
                v-model="item.startTime"
                placeholder="起始时间"
                :picker-options="{
                  start: '01:00',
                  step: '01:00',
                  end: '23:00',
                  maxTime: item.endTimeindex
                }"
                @change="handleDelete(item.startTime,item.endTime,index)"
              />
              至
              <el-time-select
                v-model="item.endTime"
                placeholder="结束时间"
                :picker-options="{
                  start: '01:00',
                  step: '01:00',
                  end: '23:00',
                  minTime: item.startTime
                }"
                :disabled="!item.startTime"
                @change="handleDelete(item.startTime,item.endTime,index)"
              />
              <el-button size="mini" type="primary" class="add-msg" @click="copy1(index)">新增消息</el-button>
              <el-button v-show="allobj1.length!=1" type="danger" icon="el-icon-close" size="mini" @click="deleteRow1(index)">删时间段</el-button>
            </div>
            <div v-for="(content, i) in item.message" :key="i" style="margin:10px 0;">
              <div class="copy_box">
                <div style="display: flex;">
                  <div>
                    <el-button size="mini" type="primary" style="margin-right:10px" icon="el-icon-s-promotion" @click="chooser(i,index)">选择消息</el-button>
                  </div>
                  <div style="display:flex;">
                    <el-button v-show="item.message.length!=1" size="mini" icon="el-icon-delete" type="danger" plain @click="deleter(i,index)" />
                    <el-tag v-if="item.message[i].sp_message_no !== ''" style="margin-right:10px">{{ item.message[i].message_name }} ( {{ item.message[i].sp_message_no }} )</el-tag>
                    <el-button v-if="item.message[i].sp_message_no !== ''" size="mini" type="primary" icon="el-icon-pie-chart" @click="look(item.message[i].sp_message_no)">预览</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button type="warning" size="mini" :disabled="loadingtable" style="margin: 20px ;" @click="saveclick">保存</el-button>
      </div>
    </div>
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <previewdialog ref="timepreview" />
    </el-dialog>
    <el-dialog
      title="选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      append-to-body
    >
      <choosetactics ref="choosetacticsview" @callback="callback" @callbackr="callbackr" />
    </el-dialog>
  </div>
</template>

<script>
import previewdialog from '../../enterpmessagelist/components/previewdialog.vue'
import { sprEnterprise } from '@/api/officialaccount.js'
import choosetactics from './choosetactics.vue'
export default {
  components: { choosetactics, previewdialog },
  data() {
    return {
      attachments: [],

      loadingtable: false,
      count: 1,
      codeid: null,
      allobj1: [
        {
          index: 1,
          id: Math.random().toString(9).substr(2, 9),
          startTime: '',
          endTime: '',
          message: [
            {
              message_name: '',
              sp_message_no: ''
            }
          ]
        }
      ],
      dialogVisible: false,
      push_method: '2',
      type: null,
      ids: null,
      messageindex: null,
      chooseindex: null,
      fatherI: null,
      priwdialogVisible: false,
      rows: []
    }
  },
  filter() {

  },
  mounted() {
  },
  methods: {
    parseTime(time) {
      const [hours, minutes] = time.split(':').map(Number)
      const now = new Date()
      now.setHours(hours, minutes, 0, 0)
      return now
    },
    handleDelete(n, o, i) {
      const nTime = this.parseTime(n)
      const oTime = this.parseTime(o)
      if (oTime < nTime) {
        // n = '' // 或者设置为其他默认值
        // console.log(77777, this.allobj1[i])
        this.allobj1[i].endTime = ''
        this.$message.error(`结束时间小于开始时间`)
      }
    },
    saveclick() {
      // console.log(1221, this.allobj1)
      // 判断allobj1中startTime不能为空
      const indexa = this.allobj1.findIndex(row => row.startTime === '' || row.startTime === null)
      if (indexa !== -1) {
        const day = indexa + 1
        this.$message({
          type: 'error',
          message: `第${day}条开始时间不能为空`
        })
        return
      }
      // 判断allobj1中endTime不能为空
      const indexe = this.allobj1.findIndex(row => row.endTime === '' || row.endTime === null)
      if (indexe !== -1) {
        const day = indexe + 1
        this.$message({
          type: 'error',
          message: `第${day}条的结束时间不能为空`
        })
        return
      }
      // // 判断时间不能重合
      const sortedRows = this.allobj1.slice().sort((a, b) => a.startTime.localeCompare(b.startTime))

      for (let i = 0; i < sortedRows.length - 1; i++) {
        const current = sortedRows[i]
        const next = sortedRows[i + 1]
        const currentIndex = this.allobj1.findIndex(item => item.startTime === current.startTime && item.endTime === current.endTime)
        const nextIndex = this.allobj1.findIndex(item => item.startTime === next.startTime && item.endTime === next.endTime)

        if (next.startTime < current.endTime) {
          if (
            next.startTime === current.startTime &&
             next.endTime === current.endTime
          ) {
            console.log('this.rows:', this.allobj1, next, current)
            this.$message({
              type: 'error',
              message: `第${current.index}条和第${next.index}条时间重叠`
            })
            return
          }
          this.$message({
            type: 'error',
            message: `第${currentIndex + 1}条和第${nextIndex + 1}条时间重叠`
          })
          return
        }
      }
      const filteredArray = this.allobj1.filter(obj => obj.startTime !== obj.endTime)
      if (filteredArray.length === 0) {
        this.$message.error(`时间段内开始时间和结束时间出现相同`)
        return
      } else if (filteredArray.length !== this.allobj1.length) {
        this.$message.error(`时间段内开始时间和结束时间出现相同`)
        return
      }

      // 判断message中的内容不能为空
      const index = this.allobj1.findIndex(row => {
        return row.startTime === '' || row.startTime === null || row.message.some(msg => {
          return msg.sp_message_no === ''
        })
      })
      if (index !== -1) {
        const day = index + 1
        const emptyMessageIndex = this.allobj1[index].message.findIndex(msg => msg.sp_message_no === '')

        if (emptyMessageIndex !== -1) {
          this.$message({
            type: 'error',
            message: `第${day}条时间段第${emptyMessageIndex + 1}个消息不能为空`
          })
        }
        return
      }

      // 转换后端要的格式
      let result = {}
      // let apiresult = {}

      const arr = []
      this.allobj1.map((time) => {
        const startHour = parseInt(time.startTime.split(':')[0])
        const endHour = parseInt(time.endTime.split(':')[0])
        const timeRange = `${startHour}-${endHour}`
        result = {
          timeRange: timeRange,
          message: time.message
        }
        arr.push(result)
      })
      // console.log('arr:', arr)
      this.$emit('tiemview', arr)
      this.$message({
        type: 'success',
        message: '时间消息选择完成'
      })
      this.allobj1 = [
        {
          index: 1,
          id: Math.random().toString(9).substr(2, 9),
          startTime: '',
          endTime: '',
          message: [
            {
              message_name: '',
              sp_message_no: ''
            }
          ]
        }
      ]
    },

    async look(id) {
      const data = await sprEnterprise({
        sp_message_no: id
      })
      this.priwdialogVisible = true
      // console.log(data.data, 'data.data', id)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },
    async callback(item) {
      // 选择完
      const data = await sprEnterprise({
        sp_message_no: item.sp_message_no
      })
      // console.log(data, 'data')
      this.dialogVisible = false
      this.allobj1[this.fatherI].message[this.chooseindex].sp_message_no = item.sp_message_no
      this.allobj1[this.fatherI].message[this.chooseindex].message_name = item.title
      this.allobj1[this.fatherI].message[this.chooseindex].attachments = data.data.attachments
      this.allobj1[this.fatherI].message[this.chooseindex].content = data.data.content
      // console.log(item)
    },
    chooserr(index, indexr) {
      this.messageindex = index
      this.messageindexr = indexr
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosetacticsview.send(2)
      })
    },
    callbackr(item) {
      // console.log('item:////', item)
      this.dialogVisible = false
      this.cemsg_data[this.messageindex].messages[this.messageindexr].sp_message_no = item.sp_message_no
      this.cemsg_data[this.messageindex].messages[this.messageindexr].title = item.title
      // console.log(item)
    },
    // 选择消息
    chooser(index, fatherI) {
      // console.log(index, 'index')
      this.chooseindex = index
      this.fatherI = fatherI
      this.dialogVisible = true
      // console.log('push_method', this.push_method)
      // console.log('this.type', this.type)
      this.$nextTick(() => {
        this.$refs.choosetacticsview.send(1, this.push_method, this.type, this.ids)
      })
    },
    deleter(i, index) {
      this.allobj1[index].message.splice(i, 1)
    },

    copy1(i) {
      this.allobj1[i].message.push({
        message_name: '',
        sp_message_no: ''
      })
    },
    sendr(row, type, id, push_method, ids) {
      this.type = id
      // this.ids = ids
      // this.push_method = push_method
      this.codeid = null
      if (type === 2) {
        if (id === 2) {
          this.codeid = id
        }
        this.allobj1 = row.map((v, i) => {
          // const tiem = ''
          // tiem = id === 2 ? v.timeRange : v
          const [start, end] = v.timeRange.split('-')
          const formattedStart = this.formatTime(start)
          const formattedEnd = this.formatTime(end)
          let message = {}
          if (id === 2) {
            message = v.message.map(v => {
              return {
                message_name: v.title,
                sp_message_no: v.sp_message_no
              }
            })
          }
          this.count = i + 1
          return {
            index: i + 1,
            id: Math.random().toString(9).substr(2, 9),
            startTime: formattedStart,
            endTime: formattedEnd,
            message: id === 2 ? message : v.message
          }
        })
      }
    },
    formatTime(time) {
      const paddedTime = time.toString().padStart(2, '0')
      return `${paddedTime}:00`
    },
    addChild1() {
      this.count++
      this.allobj1.push(
        {
          index: this.count,
          id: Math.random().toString(9).substr(2, 9),
          startTime: '',
          endTime: '',
          message: [
            {
              message_name: '',
              sp_message_no: ''
            }
          ]
        })
      console.log('this.count:', this.count)
    },
    deleteRow1(index) {
      --this.count
      this.allobj1.splice(index, 1)
      console.log('this.count:', this.count)
    }
  }
}
</script>

<style scoped>
.container{
  margin-left: 20px;
}
.copy_box{
  display: flex;
  /* align-items: center;
  margin-bottom: 20px;
  padding-left: 34px; */
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 127px;
}
</style>
<style scoped>
/* @import url(); 引入css类 */
.within_box{
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 23px;
  margin-top: 15px;
}
.title_boxr{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 157px;
}
.imaetext{
  display: flex;
  justify-content: space-between;
}
.se_top{
  margin-top: 14px;
}
.describe_text{
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard{
  width: 150px;
  height: 200px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 23px;
}
.mincard_title{
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox{
  width: 100%;
  height: 100px;
}
.line{
  width: 100%;
  height: 1px;
  background: #999999;
  /* margin: 5px 0px; */
  margin: 3px 0px;
}
.bottomwr{
  display: flex;
  align-items: center;
}
.mincard_enjoy{
  margin-bottom: 5px;
  width: 134px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar{
  margin-left: 2px;
  font-size: 12px;
}
.all_box{
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox{
  display: flex;
  align-items: center;
}
.swr{
  width: 50px;
  text-align: right;
}
.prview_box{
  /* max-height: 500px;
  overflow: hidden;
  overflow-y: scroll; */
  display: flex;
}
.prview_box::-webkit-scrollbar {
  width: 0;
}
.box_serw{
  color: rgb(169, 162, 151);
  font-size: 14px;
}
.phoner_box{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    margin:0 auto;
    position: relative;
}
.phoner_boxone{
    background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
    background-size: 100% 100%;
    width: 300px;
    height: 600px;
    position: relative;
}
.at_box{
  /* margin: 10px 0px; */
  transform: scale(0.5);
  margin-top: -72px;
  margin-left: -40px;
}
.el-button--danger.is-plain {
    color: #ff4949;
    background: #ffeded;
    border-color: #ffb6b6;
    height: 30px;
    margin-right: 10px;
}
.all_boxr{
  max-height: 365px;
  overflow-y: auto;
  position: absolute;
  top: 120px;
  padding-left: 20px;
  box-sizing: border-box;
  width: 92%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #ededed;
  border-radius: 5px;
}
.content_box{
  padding: 20px;
}
.form_box{
  margin-left: 60px;
}
.send_message{
  text-align: center;
  width: 360px;
  font-size: 18px;
  margin-bottom: 30px;
}
.add-msg{
  margin:10px 0px;
  margin-left:30px;
}
@media (max-width: 768px){
  .el-date-editor.el-input{
    width:40% !important;
  }
  .add-msg{
    margin:10px 0px;
    margin-left:0px;
  }
}
</style>
